import actionTypes from "_constants/actionTypes";

export const tutorAuthActions = {
  login,
  endTransaction,
  forgotPassword,

  logout,
  getUserToken,
  activateCounselorByToken,
  register,
  contractCenter,
  registerCenter,
  getTutors,
  activateTutorById,
  getInfoCenter,
};

function getInfoCenter(payload) {
  return {
    type: actionTypes.INFO_CENTER,
    payload: payload,
  };
}
function endTransaction() {
  return {
    type: actionTypes.END_TRANSACTION,
  };
}
function register(payload) {
  return {
    type: actionTypes.REGISTER_TUTOR,
    payload: payload,
  };
}

function contractCenter(payload) {
  return {
    type: actionTypes.PDF_CENTER,
    payload: payload,
  };
}
function registerCenter(payload) {
  return {
    type: actionTypes.REGISTER_CENTER,
    payload: payload,
  };
}

function getUserToken(token) {
  return {
    type: actionTypes.GET_USER,
    token: token,
  };
}
function activateCounselorByToken(token) {
  return {
    type: actionTypes.ACTIVATE_COUNSELOR_BY_TOKEN,
    payload: {token},
  };
}

function login(email, password, remember) {
  const payload = {email, password, remember};
  return {
    type: actionTypes.LOGIN_TUTOR,
    payload,
  };
}
function forgotPassword(email) {
  const payload = {email};
  return {
    type: actionTypes.TUTOR_FORGOTPASSWORD,
    payload,
  };
}
/*
function resetPassword(email, password, reppassword) {
  const payload = { email, password, reppassword };

  return {
    type: actionTypes.RESETPASSWORD,
    payload
    };
}
*/

function logout() {
  return {
    type: actionTypes.LOGOUT,
    payload: "",
  };
}
function getTutors() {
  return {
    type: actionTypes.GET_TUTORS,
    payload: "",
  };
}

function activateTutorById(id) {
  const payload = {id};
  return {
    type: actionTypes.ACTIVATE_TUTOR_BY_ID,
    payload: payload,
  };
}
